import Icon from '../../../../components/forms/icon.component';

interface FormValues {
  typeCampaign: string;
  name: string;
  channelsAvailable: Array<string>;
  accountCahnnels: Array<Array<object>>;
  account: string;
  companies: string;
  uniqueSend: boolean;
  headers: string;
  headersOptions: any;
  headersSelects: any;
  separator: string;
  programing: boolean;
  dateHour: string;
  timeZone: string;
  dosing: boolean;
  initHour: string;
  finishHour: string;
  blacklistSwitch: boolean;
  blacklist: any;
  channel: string;
  flowSelected: string;
  flowsRcs: any;
  // Channel SMS
  keyBase: string;
  total_character: number;
  total_credits: number;
  accents: boolean;
  msgSMS: string;
  masks: string;
  complementsSwitch: boolean;
  complements: string;
  phone_number: string;
  msgWhatsAppLink: string;
  urlLink: string;
  totalCaracteresSms: number;
  //  Channel RCS:
  typeRCS: string;
  templatesRCS: string;
  agentsRCS: string;
  previewTemplateRcs: any;
  //  Channel WA:
  templatesWa: string;
  accountsWa: string;
  columnsVariables: any;
  previewTemplateWa: any;
  vars: Record<string, Record<string, string>>;
  // Channel Email
  templatesEmail: string;
  accountsEmail: string;
  subjectEmail: string;
  previewTemplateEmail: any;
  varsEmail: Record<string, Record<string, string>>;
  columnsVariablesEmail: any;
  // fallback 1
  channelfallback: string;
  trySecondFallback: boolean;
  // fallback 2
  secondChannelfallback: string;
  objects: string;
  channelFlows: Array<string>;
  defaultChannel: string;
  // events
  events: {
    wa: {
      failed: boolean;
      failedChannel: string;
      followUp: boolean;
      followUpTime: string;
      followUpTimeUnit: string;
      followUpTemplateSent: string;
      followUpTemplateDelivered: string;
      followUpOnSent: boolean;
      followUpOnDelivered: boolean;
      changeChannel: boolean;
      changeChannelTime: string;
      changeChannelTimeUnit: string;
      changeChannelTarget: string;
      changeChannelOnSent: boolean;
      changeChannelOnDelivered: boolean;
    };
    sms: {
      failed: boolean;
      failedChannel: string;
      followUp: boolean;
      followUpTime: string;
      followUpTimeUnit: string;
      followUpMessage: string;
      followUpOnSent: boolean;
      followUpOnDelivered: boolean;
    };
    rcs: {
      failed: boolean;
      failedChannel: string;
      followUp: boolean;
      followUpTime: string;
      followUpTimeUnit: string;
      followUpTemplate: string;
      followUpTemplateSent: string;
      followUpTemplateDelivered: string;
      followUpOnSent: boolean;
      followUpOnDelivered: boolean;
      changeChannel: boolean;
      changeChannelTime: string;
      changeChannelTimeUnit: string;
      changeChannelTarget: string;
      changeChannelOnSent: boolean;
      changeChannelOnDelivered: boolean;
    };
    mail: {
      failed: boolean;
      failedChannel: string;
      followUp: boolean;
      followUpTime: string;
      followUpTimeUnit: string;
      followUpTemplate: string;
      followUpTemplateSent: string;
      followUpTemplateDelivered: string;
      followUpOnSent: boolean;
      followUpOnDelivered: boolean;
    };
  };
}

export const defaultValues: FormValues = {
  typeCampaign: 'DEFAULT',
  flowSelected: '',
  flowsRcs: [],
  // stepper 1
  name: '',
  channelsAvailable: [],
  accountCahnnels: [],
  companies: '',
  account: '',
  // stepper 2
  uniqueSend: false,
  headers: '',
  headersOptions: [],
  headersSelects: [],
  separator: '',
  // stepper 3
  programing: false,
  dateHour: '',
  timeZone: '',
  dosing: false,
  initHour: '',
  finishHour: '',
  blacklistSwitch: false,
  blacklist: '',
  // stepper 4
  channel: '',
  typeRCS: '',
  // Channel SMS
  keyBase: '',
  total_character: 0,
  total_credits: 0,
  accents: false,
  msgSMS: '',
  masks: '',
  complementsSwitch: false,
  complements: '',
  totalCaracteresSms: 0,
  // WHATSAPP_LINK
  phone_number: '',
  msgWhatsAppLink: '',
  // LINK
  urlLink: '',
  // Channel RCS
  templatesRCS: '',
  agentsRCS: '',
  previewTemplateRcs: [],
  // Channel WA
  templatesWa: '',
  accountsWa: '',
  columnsVariables: '',
  previewTemplateWa: [],
  vars: {
    header: {},
    body: {},
    footer: {},
    buttons: {}
  },
  // Channel Email
  templatesEmail: '',
  accountsEmail: '',
  subjectEmail: '',
  previewTemplateEmail: null,
  varsEmail: {
    SUBJECT: {},
    BODY: {}
  },
  columnsVariablesEmail: {
    SUBJECT: {},
    BODY: {}
  },
  // fallback 1
  channelfallback: '',
  trySecondFallback: false,
  // fallback 2
  secondChannelfallback: '',
  objects: '',
  channelFlows: [],
  defaultChannel: '',
  // events
  events: {
    wa: {
      failed: false,
      failedChannel: '',
      followUp: false,
      followUpTime: '',
      followUpTimeUnit: '',
      followUpOnSent: false,
      followUpOnDelivered: false,
      followUpTemplateSent: '',
      followUpTemplateDelivered: '',
      changeChannel: false,
      changeChannelTime: '',
      changeChannelTimeUnit: '',
      changeChannelTarget: '',
      changeChannelOnSent: false,
      changeChannelOnDelivered: false
    },
    sms: {
      failed: false,
      failedChannel: '',
      followUp: false,
      followUpTime: '',
      followUpTimeUnit: '',
      followUpMessage: '',
      followUpOnSent: false,
      followUpOnDelivered: false
    },
    rcs: {
      failed: false,
      failedChannel: '',
      followUp: false,
      followUpTime: '',
      followUpTimeUnit: '',
      followUpTemplate: '',
      followUpTemplateSent: '',
      followUpTemplateDelivered: '',
      followUpOnSent: false,
      followUpOnDelivered: false,
      changeChannel: false,
      changeChannelTime: '',
      changeChannelTimeUnit: '',
      changeChannelTarget: '',
      changeChannelOnSent: false,
      changeChannelOnDelivered: false
    },
    mail: {
      failed: false,
      failedChannel: '',
      followUp: false,
      followUpTime: '',
      followUpTimeUnit: '',
      followUpTemplate: '',
      followUpOnSent: false,
      followUpOnDelivered: false,
      followUpTemplateSent: '',
      followUpTemplateDelivered: ''
    }
  }
};

export const listTypeRCS = [
  { value: 'rcs_conversational', label: 'RCS Conversacional' },
  { value: 'rcs_single', label: 'RCS Simple' },
  { value: 'rcs_basic', label: 'RCS Básico' }
];

export const separatorList = [
  { value: 'COMMA', label: 'Coma (,)' },
  { value: 'PIPE', label: 'Pipe (|)' },
  { value: 'TAB', label: 'Tab (↹)' },
  { value: 'SPACE', label: 'Espacio ( )' }
];

export const zone = [
  { value: 'America/Tijuana', label: '(UTC-8:00) Tijuana, Baja California' },
  {
    value: 'America/Sinaloa',
    label: '(UTC-7:00) Hermosillo, Sonora, Mazatlán, Sinaloa, Tepic, Nayarit'
  },
  {
    value: 'America/Mexico_City',
    label: '(UTC-6:00) Ciudad de México, Guadalajara, Monterrey'
  },
  { value: 'America/Cancun', label: '(UTC-5:00) Cancún, Quintana Roo' }
];

export const stepsStandar = [
  {
    number: 1,
    title: 'Nombre y Empresa',
    description: 'Ingresa los datos necesarios.',
    isCurrent: true
  },
  {
    number: 2,
    title: 'Archivo Base',
    description: 'Carga tu archivo y elige los números.'
  },
  {
    number: 3,
    title: 'Programación',
    description: 'Decide en que momento mandamos tu campaña.'
  },
  {
    number: 4,
    title: 'Canal de envío',
    description: 'Elige el canal de tu preferencia.'
  }
];

export const stepsFlows = [
  {
    number: 1,
    title: 'Nombre y Empresa',
    description: 'Ingresa los datos necesarios.',
    isCurrent: true
  },
  {
    number: 2,
    title: 'Archivo Base',
    description: 'Carga tu archivo y elige los números.'
  },
  {
    number: 3,
    title: 'Programación',
    description: 'Decide en que momento mandamos tu campaña.'
  },
  {
    number: 4,
    title: 'Configuración de canales',
    description: 'Elige el canal de tu preferencia.'
  }
];

export const optionsChannels = [
  {
    value: 'sms',
    title: 'SMS',
    icon: <Icon icon="ki-message-text-2" type="" size="fs-3x" />,
    bgClass: 'bg-light',
    type: 'bg-c'
  },
  {
    value: 'wa',
    title: 'WhatsApp',
    icon: <Icon icon="ki-whatsapp" type="primary" size="fs-3x" />,
    bgClass: 'bg-light-primary',
    type: 'bg-c'
  },
  {
    value: 'rcs',
    title: 'RCS',
    icon: <Icon icon="ki-messages" type="info" size="fs-3x" />,
    bgClass: 'bg-light-info',
    type: 'bg-c'
  },
  {
    value: 'email',
    title: 'Email',
    icon: <Icon icon="ki-message-text-2" type="primary" size="fs-3x" />,
    bgClass: 'bg-light-primary',
    type: 'bg-c'
  }
];

export const optionsObject = [
  { value: 'delivered_reads', label: 'Entrega / Lectura' },
  { value: 'answer', label: 'Respuestas' }
];

export const optionsChannelsFlows = [
  { value: 'wa', label: 'Whastapp' },
  { value: 'sms', label: 'SMS' },
  { value: 'rcs', label: 'RCS' },
  { value: 'mail', label: 'Email' }
];

export const optionsComplements = [
  { value: 'WHATSAPP_LINK', label: 'Link WhatsApp' },
  { value: 'LINK', label: 'Link' }
];

export const agentsRCSOptionsProvicional = [
  { value: '6809bc65ace1bebaf1ca975a', label: 'Agente RCS' }
];
